import InquiryNoticeBox from '@/components/help/common/InquiryNoticeBox';

const ReportNotice = () => {
  return (
    <InquiryNoticeBox
      title='신고 전 확인해보세요!'
      list={[
        {
          text: '증거자료가 없을 경우 신고가 불가능 합니다.',
        },
        {
          text: '운영정책의 위반 정도에 따라 경고부터 이용정지까지 처리 될 수 있으며, 음란물 및 운영정책 위반 정도가 심할 경우 경고 없이 바로 이용정지 될 수 있습니다.',
        },
        {
          text: '타인을 비방하거나 고의적인 허위 신고의 경우 신고자 또한 제재를 받을 수 있습니다.',
        },
      ]}></InquiryNoticeBox>
  );
};

export default ReportNotice;
